var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('font-awesome-icon',{staticClass:"loading_icon",attrs:{"icon":"spinner","spin":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }